export default {
  title: 'Запись',
};
